import Encurtador from "./Encurtador";

export default Encurtador;
